import RestService from '../services/rest';

async function getAllCableCategory(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/cableCategory/all?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getCableCategoryOptions(search) {
  return RestService.getAuthenticated(
    `panel/cableCategory/options?search=${search}`,
  );
}

async function createCableCategory(newCableCategory) {
  return RestService.postAuthenticated(
    'panel/cableCategory/create', newCableCategory,
  );
}

async function updateCableCategory(updCableCategory) {
  return RestService.putAuthenticated(
    'panel/cableCategory/update', updCableCategory,
  );
}

export default {
  getAllCableCategory,
  getCableCategoryOptions,
  createCableCategory,
  updateCableCategory,
};
